
<script>
    export default {
        template: `
            <div>
                <div class="tabs">
                    <ul>
                        <li v-for="tab in tabs" :class="{ 'is-active': tab.isActive }">
                            <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
                        </li>
                    </ul>
                </div>

                <div class="tabs-details">
                    <slot></slot>
                </div>
            </div>
        `,

        data() {
            return {tabs: [] };
        },

        created() {

            this.tabs = this.$children;

        },
        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.name == selectedTab.name);
                });
            }
        }
    }

</script>
<style scoped>
    ul{
        list-style: none;
    }
    .tabs ul {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }
    .tabs a {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        color: #4a4a4a;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-bottom: -1px;
        padding: .5em 1em;
        vertical-align: top;
    }
    a {
        color: #00d1b2;
        cursor: pointer;
        text-decoration: none;
        -webkit-transition: none 86ms ease-out;
        transition: none 86ms ease-out;
    }
    .tabs li.is-active a {
        border-bottom-color: #00d1b2;
        color: #00d1b2;
    }
</style>